import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/services/loader.service';
import { CartItem, CheckoutStore, } from 'src/app/stores/checkout.store';
import { Product } from 'src/app/stores/product.store';
import { currencyCode, imageUrl } from 'src/environments/environment';
@Component({
  selector: 'app-add-to-cart',
  templateUrl: './add-to-cart.component.html',
  styleUrls: ['./add-to-cart.component.scss'],
})
export class AddToCartComponent implements OnInit {
  @Input() productDetail: any
  @Input() productId: number;
  @Input() selectedItems: number
  imageUrl = imageUrl;
  currencyCode = currencyCode;
  productVariation: number
  addedproduct: Array<Product>
  cartIndex: number
  constructor(public checkoutStore: CheckoutStore,
    private loaderService: LoaderService,
    private translateService: TranslateService,
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    var allItems = []
    this.productDetail.filter(function (element) {
      allItems = allItems.concat(element.items)
    })
    if (this.selectedItems)
      this.addedproduct = allItems?.filter((x) => x.option_data == this.selectedItems);

    if (!this.addedproduct)
      this.addedproduct = allItems?.filter((x) => x.product_id == this.productId);
  }


  async setQty(value: number, index: number, products: Product) {
    products.qty = products.qty == 1 && value == -1 ? products.qty : products.qty + value;
    this.loaderService.showLoading();
    var optionIndex = products.options.findIndex(x => x.id === products.option_data)
    try {
      var resp = await this.checkoutStore.postCartAddUpdate({
        cart_id: Number(localStorage.getItem('cart_id')),
        product_id: products.product_id,
        qty: products.qty,
        product_variation: products.options.length > 0 ? [{ id: products.options[optionIndex].product_variation_id, variation_fields: [{ id: products.options[optionIndex].id }] }] : [],
      });

      // this.checkoutStore.cartData = resp.data;
      this.checkoutStore.cartData.cart = resp.data.cart
      this.loaderService.dismissLoading();
    } catch (error) {
      this.loaderService.dismissLoading();
      products.qty = products.qty - 1;
      this.loaderService.presentToast(error?.error?.data ? error?.error?.data : this.translateService.instant('PRODUCT_BAG.OUT_OF_STOCK'),
        'middle',
        'danger',
        2000
      );
    }
  }

  async delteItem(value: Product, index: number) {
    var response = await this.loaderService.confirmPopup(this.translateService.instant('PRODUCT_BAG.DELETE_CART_TEXT'));
    if (response) {
      this.loaderService.showLoading();
      try {
        await this.checkoutStore.removeCartItem({
          seller_id: null,
          product_id: value.product_id,
          options: value?.options?.length > 0 ? value.options[0].id : null
        });
        this.loaderService.dismissLoading();
        this.checkoutStore.getCheckout()
        this.addedproduct.splice(index, 1)
        if (this.addedproduct.length === 0) {
          this.modalCtrl.dismiss()
        }
      } catch (error) {
        this.loaderService.dismissLoading();
        this.loaderService.presentToast(
          error.error.data
            ? error.error.data
            : this.translateService.instant('RATE_ORDER.SOMETHING_WRONG'),
          'middle',
          'danger',
          2000
        );
      }

    }
  }

  dismiss() {
    this.modalCtrl.dismiss()

  }
}
